import { useUnit } from 'effector-react'
import {
  $commissionList,
  getCommissionListFx,
  $walletOptions,
  $currencyOptions,
} from 'src/pages/finSystem/balanceSummary/reports/reportCommissions/model'

export const useCommissionList = () => {
  const commissionList = useUnit($commissionList)
  const loading = useUnit(getCommissionListFx.pending)

  return { commissionList, loading }
}

export const useWalletOptions = () => {
  const walletOptions = useUnit($walletOptions)
  const currencyOptions = useUnit($currencyOptions)
  return { walletOptions, currencyOptions }
}
